// extracted by mini-css-extract-plugin
export var author = "BlogPostHeader-module--author--dca41";
export var byline = "BlogPostHeader-module--byline--61139";
export var date = "BlogPostHeader-module--date--ba562";
export var expertBadge = "BlogPostHeader-module--expert-badge--7376e";
export var header = "BlogPostHeader-module--header--70e1f";
export var hero = "BlogPostHeader-module--hero--8ec96";
export var heroContent = "BlogPostHeader-module--hero-content--1a6dc";
export var lede = "BlogPostHeader-module--lede--5e013";
export var meta = "BlogPostHeader-module--meta--eabf9";
export var parallax = "BlogPostHeader-module--parallax--57806";